export enum WidgetType {
  // WARNING: Do not change the order of the widgets or delete types without fixing type number
  LogoWidget = 0,
  ClientLogoWidget = 1,
  DeviceStateWidget = 2,
  DeviceControlWidget = 3,
  DeviceOverviewWidget = 4,
  UserDeviceControlWidget = 5,

  // add new widget types here
}
